import React, { useEffect } from 'react';
import Hero from './Hero';
import About from './About';
import Benefits from './Benefits';
import Services from './Services';
import ProductPackages, { FoundingMemberModal } from './ProductPackages';
import FAQ from './FAQ';
import Join from './Join';
import Contact from './Contact';

const Home = () => {
    useEffect(() => {
        const elements = document.querySelectorAll('.fade-in-section');
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('in-view');
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.25 }
        );
        elements.forEach((el) => observer.observe(el));
        return () => observer.disconnect();
    }, []);

    return (
        <>
            <FoundingMemberModal />
            <Hero />
            <div className="fade-in-section">
                <About />
            </div>
            <div className="fade-in-section">
                <Benefits />
            </div>
            <div className="fade-in-section">
                <ProductPackages />
            </div>
            <div className="fade-in-section">
                <Services />
            </div>
            {/* Removed Services/ProductPackages separate section */}
            <div className="fade-in-section">
                <FAQ />
            </div>
            <div className="fade-in-section">
                <Join />
            </div>
            <div className="fade-in-section">
                <Contact />
            </div>
        </>
    );
};

export default Home;
